(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const store = JSON.parse($('#fcn-store-config')?.textContent || '{}');
  const root = (store.root || '/').replace(/\/?$/, '/');
  let state = null, busy = false, lastFocus;
  const settings = () => JSON.parse($('#fcn-cart-config')?.textContent || '{}');
  const money = value => new Intl.NumberFormat(({ES:'es-ES',MX:'es-MX',CO:'es-CO',AR:'es-AR',CL:'es-CL'})[store.country] || 'es-MX', {style:'currency',currency:state?.cart.currency || store.currency || 'MXN'}).format(value / 100).replace(/^\$/, '$ ');
  const element = (tag, text, cls) => {const el = document.createElement(tag);if (text !== undefined) el.textContent = text;if (cls) el.className = cls;return el;};
  const units = item => Math.min(12,Math.max(1,parseInt(item.properties?._fcn_units,10) || 1));
  const keyOf = code => String(code || '').trim().toUpperCase();
  const unique = values => [...new Map(values.map(v => String(v || '').trim()).filter(Boolean).map(v => [keyOf(v),v])).values()];
  const activeCodes = () => {
    const cart = state?.cart;
    if (Array.isArray(cart?.discount_codes)) return unique(cart.discount_codes.filter(d => d.applicable).map(d => d.code));
    return unique([
      ...(cart?.discount_applications || []),
      ...(cart?.cart_level_discount_applications || []),
      ...(cart?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(d => d.discount_application)),
      ...(state?.discounts || [])
    ].filter(d => d?.type === 'discount_code').map(d => d.title));
  };

  async function request(path, payload, html = false) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),15000);
    try {
      const response = await fetch(root + path,{method:payload ? 'POST' : 'GET',credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:html ? 'text/html' : 'application/json',...(payload ? {'Content-Type':'application/json'} : {})},...(payload ? {body:JSON.stringify(payload)} : {})});
      const data = html ? await response.text() : await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'No pudimos actualizar el carrito. Inténtalo de nuevo.');
      return data;
    } catch (err) {
      if (err.name === 'AbortError') throw new Error('La conexión tardó demasiado. Revisa tu carrito antes de volver a intentarlo.');
      throw err;
    } finally {clearTimeout(timer);}
  }
  function parseState(html) {
    if (!html) return null;
    try {
      const node = new DOMParser().parseFromString(html,'text/html').querySelector('[data-fcn-cart-state]');
      return node ? JSON.parse(node.textContent) : null;
    } catch {return null;}
  }
  function acceptCart(cart, section) {
    // Ajax owns current prices and discounts. Liquid adds variant compare-at metadata only.
    state = {cart,variants:section?.variants || state?.variants || [],discounts:section?.discounts || []};
    render();return state;
  }
  async function refresh() {
    const [cart, section] = await Promise.all([
      request('cart.js'),
      request('?section_id=fcn-cart-state',null,true).then(parseState).catch(() => null)
    ]);
    return acceptCart(cart,section);
  }
  async function update(path, payload) {
    const data = await request(path,{...payload,sections:['fcn-cart-state'],sections_url:window.location.pathname});
    const section = parseState(data.sections?.['fcn-cart-state']);
    // add.js contains only the added lines; update.js and change.js return a complete cart.
    const cart = Array.isArray(data.items) && typeof data.total_price === 'number' ? data : await request('cart.js');
    acceptCart(cart,section);
    return data;
  }
  function showError(text) {const el = $('[data-fcn-cart-error]');if (el) {el.textContent = text || '';el.hidden = !text;}}
  function setBusy(value) {
    busy = value;
    const dialog = $('#fcn-cart');if (!dialog) return;
    dialog.setAttribute('aria-busy',String(value));
    $$('[data-fcn-change], [data-fcn-remove], [data-fcn-upsell-add], [data-fcn-coupon-form] button, [data-fcn-checkout-form] button, [data-fcn-remove-code]',dialog).forEach(b => b.disabled = value);
  }
  async function locked(task) {
    if (busy) return;
    setBusy(true);showError('');
    try {return await task();} finally {setBusy(false);}
  }
  function open() {
    const dialog = $('#fcn-cart');if (!dialog) return;
    if (!dialog.open) {lastFocus = document.activeElement;dialog.showModal();}
    document.body.classList.add('fcn-cart-is-open');
  }
  function close() {$('#fcn-cart')?.close();}
  function codeStatus(code, data = {}) {
    const match = data.discount_codes?.find(d => keyOf(d.code) === keyOf(code));
    const current = match || state?.cart.discount_codes?.find(d => keyOf(d.code) === keyOf(code));
    if (typeof current?.applicable === 'boolean') return current.applicable;
    if (activeCodes().some(c => keyOf(c) === keyOf(code))) return true;
    return null;
  }
  async function applyCodes(codes) {return update('cart/update.js',{discount:unique(codes).join(',')});}
  async function change(key, quantity) {
    try {await locked(() => update('cart/change.js',{id:key,quantity}));} catch (err) {showError(err.message);}
  }

  async function add(item, code = '', expectedUnitPrice = null) {
    return locked(async () => {
      code = String(code || '').trim();
      if (!state) await refresh();
      const beforeCodes = activeCodes();
      const beforeItems = state.cart.items.map(i => ({...i}));
      const matchItem = i => String(i.variant_id || i.id) === String(item.id) && Object.entries(item.properties || {}).every(([key,value]) => String(i.properties?.[key] ?? '') === String(value));
      const previousQuantity = beforeItems.filter(matchItem).reduce((n,i) => n+i.quantity,0);
      await update('cart/add.js',{items:[item]});
      const codes = unique([...beforeCodes,settings().automaticCode,code]);
      let result, couponError = false;
      if (codes.length) {
        try {result = await applyCodes(codes);}
        catch {
          couponError = true;
          // The product addition already succeeded. Do not ask the customer to add it again.
          try {await refresh();} catch { /* Keep the last confirmed cart. */ }
        }
      }
      const current = state.cart.items.find(matchItem);
      const hasAdvertisedPrice = Number.isFinite(expectedUnitPrice);
      const currentUnitPrice = current ? Math.round(Number(current.final_line_price ?? current.line_price)/current.quantity) : NaN;
      const priceMismatch = hasAdvertisedPrice && (!Number.isFinite(currentUnitPrice) || currentUnitPrice > expectedUnitPrice);
      if (priceMismatch) {
        // Do not keep an upsell in the cart at a higher price than the displayed offer.
        if (current) await update('cart/change.js',{id:current.key,quantity:previousQuantity});
        await applyCodes(beforeCodes);
        throw new Error('Esta oferta no está disponible con el cupón configurado. No se agregó el producto.');
      }
      const rejected = codes.filter(c => codeStatus(c,result) === false);
      if (!hasAdvertisedPrice && rejected.length && !couponError) {
        try {await applyCodes(codes.filter(c => !rejected.includes(c)));} catch {couponError = true;}
      }
      open();
      if (!hasAdvertisedPrice && (couponError || rejected.length)) showError('El producto se agregó al carrito. No se pudo aplicar el cupón; se muestra el precio actual de Shopify.');
      return state.cart;
    });
  }

  function render() {
    const list = $('[data-fcn-cart-items]');if (!state || !list) return;
    const cart = state.cart;
    list.replaceChildren();
    let baseline = 0;
    if (!cart.items.length) {
      const empty = element('div',undefined,'fcn-cart-empty');empty.append(element('p','Tu carrito está vacío.'));
      const continueButton = element('button','Seguir comprando');continueButton.type = 'button';continueButton.addEventListener('click',close);empty.append(continueButton);list.append(empty);
    }
    cart.items.forEach(item => {
      const meta = (state.variants || []).find(v => v.key === item.key || Number(v.id) === Number(item.variant_id || item.id));
      const regular = Math.max(Number(meta?.compare || 0),Number(item.original_price ?? item.price ?? 0));
      const total = Number(item.final_line_price ?? item.line_price ?? 0);
      const originalTotal = regular * item.quantity;
      baseline += originalTotal;
      const count = item.quantity * units(item);
      const row = element('article',undefined,'fcn-cart-item');row.dataset.key = item.key;
      const photo = element('a',undefined,'fcn-cart-item__image');photo.href = item.url;
      const img = element('img');img.src = item.image || item.featured_image?.url || '';img.alt = item.product_title;img.loading = 'eager';photo.append(img);row.append(photo);
      const copy = element('div',undefined,'fcn-cart-item__copy');
      if (item.vendor) copy.append(element('div',item.vendor,'fcn-cart-item__vendor'));
      const title = element('a',item.product_title,'fcn-cart-item__title');title.href = item.url;copy.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title' && !item.properties?._fcn_offer) copy.append(element('p',item.variant_title,'fcn-cart-item__variant'));
      const prices = element('div',undefined,'fcn-cart-item__prices');
      if (originalTotal > total) prices.append(element('s',money(regular/units(item))));
      prices.append(element('strong',money(total/count)));copy.append(prices);
      const discounts = element('div',undefined,'fcn-cart-item__discounts');
      const labels = unique([item.properties?._fcn_offer,...(item.line_level_discount_allocations || []).map(d => d.discount_application?.title)]);
      labels.forEach(label => discounts.append(element('span',label)));copy.append(discounts);
      const bottom = element('div',undefined,'fcn-cart-item__bottom');
      const quantity = element('div',undefined,'fcn-cart-quantity');quantity.setAttribute('aria-label','Cantidad');
      const quantityButton = (symbol,value,label) => {const b=element('button',symbol);b.type='button';b.dataset.fcnChange='';b.setAttribute('aria-label',label);b.disabled=busy;b.addEventListener('click',()=>change(item.key,value));return b;};
      quantity.append(quantityButton('−',Math.max(0,item.quantity-1),'Reducir cantidad'),element('span',String(count)),quantityButton('+',item.quantity+1,'Aumentar cantidad'));
      const line = element('div',undefined,'fcn-cart-item__line');if (originalTotal > total) line.append(element('s',money(originalTotal)));line.append(element('strong',money(total)));
      bottom.append(quantity,line);copy.append(bottom);row.append(copy);
      const remove = element('button',undefined,'fcn-cart-item__remove');remove.type='button';remove.dataset.fcnRemove='';remove.setAttribute('aria-label','Eliminar producto');remove.disabled=busy;
      remove.innerHTML='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 9v9m4-9v9"/></svg>';
      remove.addEventListener('click',()=>change(item.key,0));row.append(remove);list.append(row);
    });
    const savings = Math.max(0,baseline-cart.total_price);
    const savingsRow = $('[data-fcn-cart-saving-row]');if (savingsRow) {savingsRow.hidden=!savings;$('[data-fcn-cart-saving]').textContent='−'+money(savings);}
    $('[data-fcn-cart-total]').textContent=money(cart.total_price);
    $('[data-fcn-cart-bottom]').hidden=!cart.items.length;
    const shipping = $('[data-fcn-cart-shipping]');if (shipping) shipping.hidden=!cart.items.length;
    $$('[data-fcn-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const ids = new Set(cart.items.map(i=>String(i.product_id)));
    const upsellSettings=settings();
    $$('[data-fcn-upsell]').forEach(el=>el.hidden=Boolean(upsellSettings.hideAddedUpsells && ids.has(el.dataset.productId)));
    const upsells=$('[data-fcn-upsells]');if (upsells) upsells.hidden=!$$('[data-fcn-upsell]:not([hidden])').length && !upsellSettings.designMode;
    const codes=$('[data-fcn-cart-codes]');codes.replaceChildren();
    // Automatic/offer codes are already named on the item; show removable pills for customer-entered codes only.
    if ($('[data-fcn-coupon-form]')) activeCodes().forEach(code=>{
      const b=element('button',code+' ×');b.type='button';b.dataset.fcnRemoveCode='';b.setAttribute('aria-label','Quitar cupón '+code);
      b.addEventListener('click',async()=>{try{await locked(()=>applyCodes(activeCodes().filter(c=>keyOf(c)!==keyOf(code))));}catch(err){showError(err.message);}});codes.append(b);
    });
    document.dispatchEvent(new CustomEvent('fcn:cart:updated',{detail:{cart}}));
  }

  function init() {
    $$('[data-fcn-open-cart]').forEach(b=>{
      if(b.dataset.fcnReady)return;
      b.dataset.fcnReady='true';
      b.addEventListener('click',async()=>{open();try{await refresh();}catch(err){showError(err.message);}});
    });
    const dialog=$('#fcn-cart');if (!dialog || dialog.dataset.fcnReady) return;dialog.dataset.fcnReady='true';
    $$('[data-fcn-close-cart]',dialog).forEach(b=>b.addEventListener('click',close));
    dialog.addEventListener('close',()=>{document.body.classList.remove('fcn-cart-is-open');lastFocus?.focus();});
    dialog.addEventListener('click',e=>{if(e.target===dialog && e.clientX<dialog.getBoundingClientRect().left) close();});
    const track=$('[data-fcn-upsell-track]');
    function move(direction) {if(!track)return;const cards=$$('[data-fcn-upsell]:not([hidden])',track);if(!cards.length)return;const index=Math.round(track.scrollLeft/(track.clientWidth+10));const target=(index+direction+cards.length)%cards.length;track.scrollTo({left:cards[target].offsetLeft-cards[0].offsetLeft,behavior:'smooth'});}
    $('[data-fcn-upsell-prev]')?.addEventListener('click',()=>move(-1));$('[data-fcn-upsell-next]')?.addEventListener('click',()=>move(1));
    $$('[data-fcn-upsell-add]').forEach(button=>button.addEventListener('click',async()=>{
      const item={id:button.dataset.variantId,quantity:1,properties:{_fcn_upsell:'true'}};
      const code=button.dataset.code;const expected=code ? Math.round(Number(button.dataset.price)*(100-Number(button.dataset.percent || 0))/100) : null;
      try{await add(item,code,expected);}catch(err){showError(err.message);}
    }));
    $$('[data-fcn-upsell-variant]').forEach(select=>select.addEventListener('change',()=>{
      const card=select.closest('[data-fcn-upsell]'),option=select.selectedOptions[0],button=$('[data-fcn-upsell-add]',card);
      button.dataset.variantId=option.value;button.dataset.price=option.dataset.price;
      const price=Number(option.dataset.price)*(button.dataset.code ? 1-Number(button.dataset.percent || 0)/100 : 1);
      const compare=button.dataset.code ? Number(option.dataset.price) : Number(option.dataset.compare);
      $('[data-fcn-upsell-price]',card).textContent=money(Math.round(price));const s=$('[data-fcn-upsell-compare]',card);s.textContent=money(compare);s.hidden=compare<=price;
    }));
    $('[data-fcn-coupon-form]')?.addEventListener('submit',async e=>{
      e.preventDefault();const code=$('[name="discount"]',e.target).value.trim();if(!code)return;
      const status=$('[data-fcn-coupon-status]');
      try{await locked(async()=>{if(!state)await refresh();const previous=activeCodes();const data=await applyCodes([...previous,code]);const applied=codeStatus(code,data);status.textContent=applied===true?'Cupón aplicado.':applied===false?'Este cupón no es válido para tu carrito.':'El cupón se comprobará al continuar con el pago.';status.hidden=false;if(applied===false)await applyCodes(previous);});}catch(err){showError(err.message);}
    });
    $('[data-fcn-checkout-form]')?.addEventListener('submit',e=>{if(busy)e.preventDefault();});
    if(state)render();
  }
  window.FaceCleanStoreCart={add,open:async()=>{open();await refresh();},refresh};
  init();
  document.addEventListener('shopify:section:load',()=>{init();});
  document.addEventListener('shopify:section:select',e=>{if(e.target.querySelector('#fcn-cart'))window.FaceCleanStoreCart.open().catch(err=>showError(err.message));});
})();
